import React from 'react';
import { useTheme } from 'styled-components';

interface IconProps {
    color?: string;
    size?: number;
}

export const IconDocument: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4zm13.586 4L14 4.414V8h3.586zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1V4zm-4 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconBalanceScale: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 6.5V7.5C15 8.88 13.88 10 12.5 10S10 8.88 10 7.5V6.5L4 7V9L10 8.5V9.5C10 10.88 11.12 12 12.5 12S15 10.88 15 9.5V8.5L21 9ZM12 14C13.1 14 14 14.9 14 16C14 17.1 13.1 18 12 18C10.9 18 10 17.1 10 16C10 14.9 10.9 14 12 14ZM21 21V19L15 18.5V19.5C15 20.88 13.88 22 12.5 22S10 20.88 10 19.5V18.5L4 19V21L10 20.5V21.5C10 22.88 11.12 24 12.5 24S15 22.88 15 21.5V20.5L21 21Z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconClock: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconPersonLocation: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                fill={defaultColor}
            />
            <circle cx="18" cy="8" r="3" fill={defaultColor} />
            <path
                d="M18 12C15.79 12 14 10.21 14 8C14 5.79 15.79 4 18 4C20.21 4 22 5.79 22 8C22 10.21 20.21 12 18 12ZM18 14C15.33 14 10 15.34 10 18V20H26V18C26 15.34 20.67 14 18 14Z"
                fill={defaultColor}
            />
        </svg>
    );
};


export const IconPushpin: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 4V2L8 2V4L16 4ZM16 6L8 6V8L16 8V6ZM16 10L8 10V12L16 12V10ZM16 14L8 14V16L16 16V14ZM16 18L8 18V20L16 20V18ZM16 22L8 22V24L16 24V22Z"
                fill={defaultColor}
            />
            <circle cx="12" cy="3" r="1" fill={defaultColor} />
        </svg>
    );
};

export const IconLocationPin: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5Z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconEnvelope: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconeSinalAlerta: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                x1="11.9999"
                y1="8.27274"
                x2="11.9999"
                y2="13.7273"
                stroke={defaultColor}
                strokeWidth="1.81818"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 17.3636L12 17.3719"
                stroke={defaultColor}
                strokeWidth="1.81818"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.7677 18.4635L13.6512 4.89384C12.9383 3.70205 11.0617 3.70205 10.3488 4.89385L2.23231 18.4635C1.54868 19.6065 2.45582 21 3.88347 21H20.1165C21.5442 21 22.4513 19.6065 21.7677 18.4635Z"
                stroke={defaultColor}
                strokeWidth="1.81818"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconCheckCircunferenciaConclusao: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22 11.08V12a10 10 0 11-5.93-9.14"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <polyline
                points="22 4 12 14.01 9 11.01"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export const IconFolhaPreenchida: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM16 13H8V11H16V13ZM16 17H8V15H16V17Z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconAlvo: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="12"
                r="10"
                stroke={defaultColor}
                strokeWidth="2"
                fill="none"
            />
            <circle
                cx="12"
                cy="12"
                r="6"
                stroke={defaultColor}
                strokeWidth="2"
                fill="none"
            />
            <circle
                cx="12"
                cy="12"
                r="2"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconFecharCircunferencia: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 8v4"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 16h.01"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconDocumentUpload: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.5858,2 C14.0572667,2 14.5115877,2.16648691 14.870172,2.46691468 L15,2.58579 L19.4142,7 C19.7476222,7.33339556 19.9511481,7.77238321 19.9922598,8.23835797 L20,8.41421 L20,20 C20,21.0543909 19.18415,21.9181678 18.1492661,21.9945144 L18,22 L6,22 C4.94563773,22 4.08183483,21.18415 4.00548573,20.1492661 L4,20 L4,4 C4,2.94563773 4.81587733,2.08183483 5.85073759,2.00548573 L6,2 L13.5858,2 Z M12,4 L6,4 L6,20 L18,20 L18,10 L13.5,10 C12.6716,10 12,9.32843 12,8.5 L12,4 Z M11.2929,11.1729 C11.6533615,10.8124385 12.2206207,10.7847107 12.6128973,11.0897166 L12.7071,11.1729 L14.8284,13.2942 C15.219,13.6847 15.219,14.3179 14.8284,14.7084 C14.4679385,15.0689538 13.9006793,15.0966888 13.5084027,14.7916047 L13.4142,14.7084 L13,14.2942 L13,17 C13,17.5523 12.5523,18 12,18 C11.48715,18 11.0644908,17.613973 11.0067275,17.1166239 L11,17 L11,14.2942 L10.5858,14.7084 C10.1953,15.099 9.5621,15.099 9.17157,14.7084 C8.81109,14.3479385 8.78336077,13.7806793 9.08838231,13.3884027 L9.17157,13.2942 L11.2929,11.1729 Z M14,4.41421 L14,8 L17.5858,8 L14,4.41421 Z"
                fill={color || defaultColor}
            />
        </svg>
    );
};

export const IconExternalLink: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M15 3H21M21 3V9M21 3L10 14"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export const IconPencil: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.71 5.04C21.1 5.43 21.1 6.06 20.71 6.45L7.16 20L3 21L4 16.84L17.55 3.29C17.94 2.9 18.57 2.9 18.96 3.29L20.71 5.04Z"
                stroke={defaultColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export const IconDisqueteSalvar: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={defaultColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
        </svg>
    );
};

export const IconPonto: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme.colors.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="12"
                r="5"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconRecusada: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme?.colors?.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 8C21.5523 8 22 8.44772 22 9V23H24V12C24 11.4477 24.4477 11 25 11C25.5523 11 26 11.4477 26 12V26.7127C26 28.589 28.351 29.4325 29.5439 27.9841L33.1878 23.5593C33.6615 22.984 34.528 22.9422 35.055 23.4692C35.4617 23.8759 35.5421 24.5062 35.2504 25.002L29.0897 35.4752C27.4406 38.2787 24.431 40 21.1785 40C16.1093 40 12 35.8907 12 30.8215V17C12 16.4477 12.4477 16 13 16C13.5523 16 14 16.4477 14 17V25H16V12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12V23H20V9C20 8.44772 20.4477 8 21 8ZM18 9.17071V9C18 7.34315 19.3431 6 21 6C22.6569 6 24 7.34315 24 9V9.17071C24.3128 9.06015 24.6494 9 25 9C26.6568 9 28 10.3431 28 12V26.7127L31.6439 22.2879C32.8683 20.8012 35.1073 20.6931 36.4692 22.055C37.5203 23.1061 37.728 24.7348 36.9743 26.016L30.8136 36.4892C28.8051 39.9036 25.1397 42 21.1785 42C15.0048 42 10 36.9952 10 30.8215V17C10 15.3431 11.3431 14 13 14C13.3506 14 13.6872 14.0602 14 14.1707V12C14 10.3431 15.3431 9 17 9C17.3506 9 17.6872 9.06015 18 9.17071Z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconUpload: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme?.colors?.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={defaultColor}
                d="M19.3107659,12.0514519 C19.6914194,12.0514519 20,12.3646267 20,12.7509475 L20,17.6690264 C19.9938202,18.3388667 19.8725879,18.8692232 19.6014711,19.2629832 C19.2734293,19.7394192 18.692794,19.9546046 17.8541437,20 L1.95063965,19.9982693 C1.30493215,19.9520847 0.783122117,19.6957368 0.444258688,19.2213785 C0.141889579,18.7981068 -0.00168144063,18.2714304 0,17.6625107 L0,12.7509492 C0,12.3646285 0.3085815,12.0514519 0.689234956,12.0514519 C1.06988841,12.0514519 1.37846979,12.3646249 1.37847075,12.7509457 L1.37848021,17.6644834 C1.37755618,17.9967232 1.44266621,18.235573 1.56028228,18.400218 C1.64140402,18.5137764 1.78414309,18.5838993 1.99909415,18.6010088 L17.8165968,18.6020475 C18.2362406,18.5788121 18.4438468,18.5018725 18.4715409,18.4616506 C18.5561601,18.3387527 18.6177678,18.0692372 18.6215319,17.662509 L18.6215319,12.7509475 C18.6215319,12.3646267 18.9301125,12.0514519 19.3107659,12.0514519 Z M9.99004267,0 C10.2138052,0 10.4126627,0.108218607 10.5385735,0.275898908 L14.8199853,4.58384481 C15.0903403,4.85579935 15.0922778,5.2986911 14.8243128,5.57307121 C14.5563478,5.84745133 14.1199533,5.84941764 13.8495983,5.5774631 L13.8495983,5.5774631 L10.679,2.388 L10.6792767,12.0312282 C10.6792767,12.4175489 10.3706961,12.7307237 9.99004267,12.7307237 C9.60938921,12.7307237 9.30080862,12.4175489 9.30080862,12.0312282 L9.3,2.383 L6.17196801,5.5740698 C5.93031044,5.82051895 5.55266265,5.84603478 5.28285432,5.65001654 L5.19724674,5.57647134 C4.92743145,5.3039653 4.92637202,4.86107049 5.19488043,4.58723811 L5.19488043,4.58723811 L9.49085833,0.206079767 C9.60417971,0.0905114571 9.74742341,0.0235159351 9.89543581,0.00518085699 C9.89909017,0.00602663088 9.90269067,0.00555466379 9.90629978,0.00511100628 C9.9298388,0.00139122319 9.95343509,8.63925827e-05 9.97703552,4.14935211e-06 L9.99004267,0 L9.99004267,0 Z"
            />
        </svg>
    );
};

export const IconeDrawer: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme?.colors?.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1022.98 509.984L905.475 102.895c-3.84-13.872-16.464-23.472-30.848-23.472H139.283c-14.496 0-27.184 9.744-30.944 23.777L.947 489.552c-1.984 7.504-1.009 15.007 1.999 21.536C1.218 516.88.003 522.912.003 529.264v351.312c0 35.343 28.656 64 64 64h896c35.343 0 64-28.657 64-64V529.264c0-1.712-.369-3.329-.496-5.008.832-4.592.816-9.44-.527-14.272zm-859.078-366.56l686.369-.001 93.12 321.84H645.055c-1.44 76.816-55.904 129.681-133.057 129.681s-130.624-52.88-132.064-129.68H74.158zm796.097 737.151H64.001V529.263h263.12c27.936 80.432 95.775 129.68 184.879 129.68s157.936-49.248 185.871-129.68h262.128v351.312z"
                fill={defaultColor}
            />
        </svg>
    );
};

export const IconeDownload: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme?.colors?.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12,3V16M8,12l4,4,4-4"
                fill="none"
                stroke={defaultColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
            <path
                d="M20,16v4a1.08,1.08,0,0,1-1.14,1H5.14A1.08,1.08,0,0,1,4,20V16"
                fill="none"
                stroke={defaultColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export const IconeCaixaDeTexto: React.FC<IconProps> = ({ color, size = 24 }) => {
    const theme = useTheme() as any;
    const defaultColor = color || theme?.colors?.secondaryGray;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 8h8m0 4H8m0 4h4m-6 4h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
                stroke={defaultColor}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
